theme.CartDrawerExtras = (function () {
  var $drawer = $('#CartDrawer');
  if (!$drawer.length) {
    return {};
  }

  var freeShippingThreshold = parseInt($drawer.attr('data-free-shipping-threshold'), 10) || 0;
  var shippingEstimateEnabled = $drawer.attr('data-shipping-estimate-enabled') === 'true';
  var shippingEstimateAmount = parseInt($drawer.attr('data-shipping-estimate'), 10) || 0;
  var freeLabel = $drawer.attr('data-free-label') || 'Gratis';
  var addLabel = $drawer.attr('data-add-label') || 'Agregar';
  var crossSellLimit = parseInt($drawer.attr('data-cross-sell-limit'), 10) || 4;

  function escapeHtml(text) {
    return $('<div>').text(text || '').html();
  }

  function updateTotals(cart) {
    if (!shippingEstimateEnabled) {
      return;
    }
    var freeShipping = freeShippingThreshold > 0 && cart.total_price >= freeShippingThreshold;
    var shippingCost = freeShipping ? 0 : shippingEstimateAmount;
    var shippingText = freeShipping ? freeLabel : theme.Currency.formatMoney(shippingCost, theme.moneyFormat);

    $('.js-cart-shipping').text(shippingText);
    $('.js-cart-total-estimate').text(theme.Currency.formatMoney(cart.total_price + shippingCost, theme.moneyFormat));
  }

  function loadCrossSell(cart) {
    var $section = $('.cart-drawer__cross-sell');
    var $list = $('.js-cross-sell-list');
    if (!$list.length) {
      return;
    }

    if (!cart.items.length) {
      $list.empty();
      $section.hide();
      return;
    }

    var productId = cart.items[0].product_id;

    $.getJSON('/recommendations/products.json', {
      product_id: productId,
      limit: crossSellLimit
    })
      .done(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) {
          $section.hide();
          return;
        }

        var html = '';
        products.forEach(function (product) {
          // Check product level available flag if it exists
          if (product.available === false) {
            return;
          }
          
          // Find the first available variant
          var availableVariant = null;
          if (product.variants && product.variants.length) {
            for (var i = 0; i < product.variants.length; i++) {
              if (product.variants[i].available) {
                availableVariant = product.variants[i];
                break;
              }
            }
          }
          
          if (!availableVariant) {
            return; // Skip if no variants are available
          }

          var variantSelect = '';
          if (product.variants && product.variants.length > 1) {
            variantSelect = '<select class="cart-drawer-cross-item__select js-cross-sell-select">';
            product.variants.forEach(function(v) {
              if (v.available) {
                variantSelect += '<option value="' + v.id + '">' + escapeHtml(v.title) + '</option>';
              }
            });
            variantSelect += '</select>';
          }

          var title = escapeHtml(product.title);
          html +=
            '<div class="cart-drawer-cross-item">' +
            '<a href="' + product.url + '" class="cart-drawer-cross-item__image"><img src="' + product.featured_image + '" alt="' + title + '"></a>' +
            '<div class="cart-drawer-cross-item__meta">' +
            '<a href="' + product.url + '" class="cart-drawer-cross-item__title">' + title + '</a>' +
            '<span class="cart-drawer-cross-item__price">' + theme.Currency.formatMoney(product.price, theme.moneyFormat) + '</span>' +
            variantSelect +
            '</div>' +
            '<button type="button" class="cart-drawer-cross-item__add js-cross-sell-add" data-variant-id="' + availableVariant.id + '">' + addLabel + '</button>' +
            '</div>';
        });

        if (!html) {
          $section.hide();
          return;
        }

        $list.html(html);
        $section.show();
      })
      .fail(function () {
        $section.hide();
      });
  }

  $(document).on('click', '.js-cross-sell-add', function () {
    var $btn = $(this);
    if ($btn.hasClass('is-loading')) {
      return;
    }
    
    var $select = $btn.closest('.cart-drawer-cross-item').find('.js-cross-sell-select');
    var variantId = $select.length ? $select.val() : $btn.data('variant-id');
    
    $btn.addClass('is-loading');

    $.post('/cart/add.js', { id: variantId, quantity: 1 }, null, 'json')
      .done(function () {
        theme.miniCart.updateElements();
        theme.miniCart.generateCart();
      })
      .fail(function (xhr) {
        var data = xhr.responseJSON;
        if (data && data.description) {
          theme.alert.new('Aviso', data.description, 3000, 'warning');
        }
      })
      .always(function () {
        $btn.removeClass('is-loading');
      });
  });

  $(document).on('click', '.js-coupon-toggle', function () {
    $(this).closest('.cart-drawer__coupon').find('.cart-drawer__coupon-field').toggleClass('is-open');
  });

  $(document).on('click', '.js-coupon-apply', function () {
    var $btn = $(this);
    var $field = $btn.closest('.cart-drawer__coupon-field');
    var $input = $field.find('.js-coupon-input');
    var code = ($input.val() || '').trim();
    if (!code) {
      return;
    }
    var appliedLabel = $btn.attr('data-applied-label') || 'Aplicado';

    $btn.prop('disabled', true);
    fetch('/discount/' + encodeURIComponent(code))
      .then(function () {
        $btn.text(appliedLabel);
      })
      .catch(function () {
        $btn.prop('disabled', false);
      });
  });

  $(document).on('cart:updated', function (_evt, cart) {
    updateTotals(cart);
    loadCrossSell(cart);
  });

  Shopify.getCart(function (cart) {
    updateTotals(cart);
    loadCrossSell(cart);
  });

  return {
    updateTotals: updateTotals,
    loadCrossSell: loadCrossSell
  };
})();
